<template>
  <vx-card>
    <div class="flex justify-end">
      <vs-button
        @click="$router.push({ name: 'custom_report' })"
        color="danger"
        type="filled"
        icon-pack="feather"
        icon="icon-x"
        class="mr-4"
        >Cancel</vs-button
      >
      <vs-button
        color="#009FB7"
        type="filled"
        icon-pack="feather"
        icon="icon-save"
        @click.prevent="saveData()"
        >Save</vs-button
      >
    </div>

    <div class="pt-8 w-full md:w-1/2">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Site</span>
        </div>
        <div
          style="min-width: 300px"
          class="vx-col w-full mb-4 sm:w-1/4 sm:mb-0"
        >
          <v-select
            :disabled="isEdit"
            label="name"
            placeholder="Site"
            class="w-full"
            v-model="site"
            :options="siteLists"
          ></v-select>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Report Name</span>
        </div>
        <div class="vx-col w-full">
          <vs-input class="w-full" v-model="report_name" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Event Code</span>
        </div>
        <div class="vx-col w-full mb-4 sm:w-full sm:mb-0">
          <v-select
            label="eventName"
            placeholder="Select event"
            class="w-full"
            v-model="event"
            :options="eventLists"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Object</span>
        </div>
        <div class="vx-col w-full mb-4 sm:w-full sm:mb-0 flex items-center">
          <div class="flex space-x-4">
            <div class="flex items-center">
              <vs-checkbox v-model="car" vs-value="1"></vs-checkbox>
              <span class="ml-2 whitespace-nowrap">Car</span>
            </div>
            <div class="flex items-center">
              <vs-checkbox v-model="motorcycle" vs-value="1"></vs-checkbox>
              <span class="ml-2 whitespace-nowrap">Motorcycle</span>
            </div>
            <div class="flex items-center">
              <vs-checkbox v-model="otherVehicle" vs-value="1"></vs-checkbox>
              <span class="ml-2 whitespace-nowrap">Other Vehicle</span>
            </div>
            <div class="flex items-center">
              <vs-checkbox v-model="person" vs-value="1"></vs-checkbox>
              <span class="ml-2 whitespace-nowrap">Person</span>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row mb-6" v-if="event != null && event.id == '14'">
        <div class="vx-col mb-1 w-full">
          <span>Type</span>
        </div>
        <div class="vx-col sm:w-1/4 w-full flex items-center">
          <vs-checkbox v-model="eventTypeIn" vs-value="1">IN</vs-checkbox>
          <vs-checkbox v-model="eventTypeOut" vs-value="2">OUT</vs-checkbox>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div v-if="cameraTreeLists.length > 0" class="vx-col w-full border">
          <OtherAccessForm
            :key="site.id"
            :edit="isEdit"
            v-model="cameraTreeLists"
          />
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import api from "@/api";
import vSelect from "vue-select";
import OtherAccessForm from "../configurations/orgs/users/other_access_tree.vue";

export default {
  data() {
    return {
      report_name: "",
      site: null,
      siteLists: [],
      event: null,
      eventLists: [],
      isEdit: false,
      cameraTreeLists: [],
      eventType: "0",
      eventTypeIn: "",
      eventTypeOut: "",
      selectedCustomReport: null,
      isInitialLoad: false,
      car: false,
      motorcycle: false,
      otherVehicle: false,
      person: false,
    };
  },
  watch: {
    site(x, y) {
      if (x != "" && x != null) {
        if (x != y) {
          this.getCameraTreePerSite();
        }
      } else {
        this.cameraTreeLists = [];
      }
    },
    eventTypeIn: "setEventType",
    eventTypeOut: "setEventType",
    event(newVal, oldVal) {
      if (newVal !== oldVal && !this.isInitialLoad) {
        this.eventTypeIn = "";
        this.eventTypeOut = "";
      }
    },
  },
  components: {
    vSelect,
    OtherAccessForm,
  },
  // beforeMount() {
  //   if (this.$route.params.id != undefined) {
  //     var selectedReport = localStorage.getItem("selectedCustomReport");
  //     if (selectedReport != null && selectedReport != undefined) {
  //       this.selectedCustomReport = JSON.parse(selectedReport);
  //       this.report_name = this.selectedCustomReport.reportName;
  //       this.eventType = this.selectedCustomReport.inOut;
  //     }
  //     this.isEdit = true;
  //     this.getCameraTreePerSite();
  //   }
  // },
  beforeMount() {
    if (this.$route.params.id != undefined) {
      var selectedReport = localStorage.getItem("selectedCustomReport");
      if (selectedReport != null && selectedReport != undefined) {
        this.selectedCustomReport = JSON.parse(selectedReport);
        this.report_name = this.selectedCustomReport.reportName;
        this.eventType = this.selectedCustomReport.inOut.toString();

        // Set eventTypeIn and eventTypeOut based on the value of this.selectedCustomReport.inOut
        if (this.eventType === "1") {
          this.eventTypeIn = "1";
          this.eventTypeOut = "";
        } else if (this.eventType === "2") {
          this.eventTypeIn = "";
          this.eventTypeOut = "2";
        } else if (this.eventType === "3") {
          this.eventTypeIn = "1";
          this.eventTypeOut = "2";
        } else {
          this.eventTypeIn = false;
          this.eventTypeOut = false;
        }

        // Set object checkboxes from the selected report
        this.car = this.selectedCustomReport.objectCar === 1;
        this.motorcycle = this.selectedCustomReport.objectMotor === 1;
        this.otherVehicle = this.selectedCustomReport.objectOtherVehicle === 1;
        this.person = this.selectedCustomReport.objectPerson === 1;
      }
      this.isEdit = true;
      this.getCameraTreePerSite();
    }
  },
  mounted() {
    this.getSiteLists();
    this.getEventLists();
  },
  methods: {
    setEventType() {
      this.eventType =
        this.eventTypeIn && this.eventTypeOut
          ? "3"
          : this.eventTypeIn
          ? "1"
          : this.eventTypeOut
          ? "2"
          : "0";
      console.log("Current value of eventType:", this.eventType);
    },
    getCameraTreePerSite() {
      let params = {
        siteId: this.site.id,
      };

      if (this.isEdit) {
        params = {
          ...params,
          customReportId: this.$route.params.id,
        };
      }

      this.$vs.loading();
      this.cameraTreeLists = [];
      api
        .getCustomReportCameraPerSite(params)
        .then((result) => result.data)
        .then((data) => {
          if (data.status) {
            this.cameraTreeLists = data.data;
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log(e);
          this.$vs.loading.close();
        });
    },
    getSiteLists() {
      if (this.$store.state.sites.length > 0) {
        this.siteLists = this.$store.state.sites;
        if (
          this.selectedCustomReport == null ||
          this.selectedCustomReport == undefined
        ) {
          this.site = this.siteLists[0];
        } else {
          const filteredSiteLists = this.siteLists.filter(
            (item) => item.id == this.selectedCustomReport.siteId
          );
          this.site = filteredSiteLists[0];
        }
      } else {
        this.$vs.loading();
        api
          .sites({
            siteName: this.searchQuery,
          })
          .then((result) => result.data)
          .then((data) => {
            if (data.status) {
              this.siteLists = data.data;
              this.$store.dispatch("updateSiteLists", data.data);
              if (
                this.selectedCustomReport == null ||
                this.selectedCustomReport == undefined
              ) {
                this.site = this.siteLists[0];
              } else {
                const filteredSiteLists = this.siteLists.filter(
                  (item) => item.id == this.selectedCustomReport.siteId
                );
                this.site = filteredSiteLists[0];
              }
            }
            this.$vs.loading.close();
          })
          .catch((e) => {
            console.log(e);
            this.$vs.loading.close();
          });
      }
    },
    getEventLists() {
      if (this.$store.state.events.length > 0) {
        this.eventLists = this.$store.state.events;
        if (
          this.selectedCustomReport != null &&
          this.selectedCustomReport != undefined
        ) {
          const filteredEventLists = this.eventLists.filter(
            (item) => item.id == this.selectedCustomReport.parameterEventId
          );
          this.isInitialLoad = true;
          this.event = filteredEventLists[0];
          this.$nextTick(() => { this.isInitialLoad = false; });
        }
      } else {
        this.$vs.loading();
        api
          .getEventLists()
          .then((result) => result.data)
          .then((data) => {
            if (data.status) {
              this.eventLists = data.data;
              this.$store.dispatch("updateEventLists", data.data);

              if (
                this.selectedCustomReport != null &&
                this.selectedCustomReport != undefined
              ) {
                const filteredEventLists = this.eventLists.filter(
                  (item) =>
                    item.id == this.selectedCustomReport.parameterEventId
                );
                this.isInitialLoad = true;
                this.event = filteredEventLists[0];
                this.$nextTick(() => { this.isInitialLoad = false; });
              }
            }
            this.$vs.loading.close();
          })
          .catch((e) => {
            console.log(e);
            this.$vs.loading.close();
          });
      }
    },
    saveData() {
      if (!this.site) {
        this.$vs.notify({
          title: "Error",
          text: "Please select a Site.",
          color: "danger",
          position: "bottom-center",
        });
        return;
      }
      if (!this.report_name) {
        this.$vs.notify({
          title: "Error",
          text: "Please enter a Report Name.",
          color: "danger",
          position: "bottom-center",
        });
        return;
      }
      if (!this.event) {
        this.$vs.notify({
          title: "Error",
          text: "Please select an Event Code.",
          color: "danger",
          position: "bottom-center",
        });
        return;
      }

      if (!this.car && !this.motorcycle && !this.otherVehicle && !this.person) {
        this.$vs.notify({
          title: "Error",
          text: "Please select at least one Object.",
          color: "danger",
          position: "bottom-center",
        });
        return;
      }
      
      if (this.cameraTreeLists.length > 0) {
        let hasSelectedCamera = false;
        for (const area of this.cameraTreeLists) {
          if (area.aksesCameraCam && area.aksesCameraCam.some(c => c.isSelected === 1)) {
            hasSelectedCamera = true;
            break;
          }
        }
        if (!hasSelectedCamera) {
          this.$vs.notify({
            title: "Error",
            text: "Please select at least one Camera.",
            color: "danger",
            position: "bottom-center",
          });
          return;
        }
      }

      console.log("Event:", this.event);
      console.log("EventType:", this.eventType);
      console.log("event.id", this.event.id);
      if (this.event !== null && this.event.id == "14") {
        if (this.eventType === "0") {
          this.$vs.notify({
            title: "Error",
            text: "Please select at least one type (IN or OUT).",
            color: "danger",
            position: "bottom-center",
          });
          return;
        }
      }
      if (this.isEdit) {
        this.updateCustomReport();
      } else {
        this.saveCustomReport();
      }
    },
    saveCustomReport() {
      this.$vs.loading();
      const params = {
        siteId: this.site.id,
        reportName: this.report_name,
        parameterEventId: this.event.id,
        InOut: this.eventType,
        aksesCameraArea: this.cameraTreeLists,
        objectCar: this.car ? 1 : 0,
        objectMotor: this.motorcycle ? 1 : 0,
        objectOtherVehicle: this.otherVehicle ? 1 : 0,
        objectPerson: this.person ? 1 : 0,
      };
      api
        .saveCustomReport(params)
        .then((result) => result.data)
        .then((data) => {
          this.$vs.loading.close();
          if (!data.status) {
            this.$vs.notify({
              title: "Error",
              text: data.message,
              color: "danger",
              position: "bottom-center",
            });
          } else {
            this.$vs.notify({
              title: "Success",
              text: "Custom report created successfully",
              color: "success",
              position: "bottom-center",
            });
            setTimeout(() => {
              this.$router.push({ name: "custom_report" });
            }, 500);
          }
        })
        .catch((e) => {
          console.log(e);
          this.$vs.loading.close();
        });
    },
    updateCustomReport() {
      this.$vs.loading();
      const params = {
        customReportId: this.$route.params.id,
        siteId: this.site.id,
        reportName: this.report_name,
        parameterEventId: this.event.id,
        InOut: this.eventType,
        aksesCameraArea: this.cameraTreeLists,
        objectCar: this.car ? 1 : 0,
        objectMotor: this.motorcycle ? 1 : 0,
        objectOtherVehicle: this.otherVehicle ? 1 : 0,
        objectPerson: this.person ? 1 : 0,
      };
      api
        .updateCustomReport(params)
        .then((result) => result.data)
        .then((data) => {
          this.$vs.loading.close();
          if (!data.status) {
            this.$vs.notify({
              title: "Error",
              text: data.message,
              color: "danger",
              position: "bottom-center",
            });
          } else {
            this.$vs.notify({
              title: "Success",
              text: "Custom report created successfully",
              color: "success",
              position: "bottom-center",
            });
            setTimeout(() => {
              this.$router.push({ name: "custom_report" });
            }, 500);
          }
        })
        .catch((e) => {
          console.log(e);
          this.$vs.loading.close();
        });
    },
    getCustomReportDetail() {
      this.$vs.loading();
      api
        .getCustomReportLists({
          customReportId: this.selectedCustomReport.id,
        })
        .then((result) => result.data)
        .then((data) => {
          if (data.status) {
            console.log(data.data);
            //this.lists = data.data
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log(e);
          this.$vs.loading.close();
        });
    },
  },
};
</script>
